/* Ashloé skin quiz — routine finder. No dependencies. */
(function () {
  var QUESTIONS = [
    {
      key: 'goal',
      title: 'What matters most to you right now?',
      help: 'Pick the one that feels closest.',
      options: [
        { value: 'hydration', label: 'Lasting hydration' },
        { value: 'glow', label: 'A brighter glow' },
        { value: 'firmness', label: 'A firmer look' },
        { value: 'calm', label: 'Comfort and calm' },
        { value: 'texture', label: 'Smoother texture' }
      ]
    },
    {
      key: 'dryness',
      title: 'How often does your skin feel dry or tight?',
      options: [
        { value: 'low', label: 'Rarely' },
        { value: 'medium', label: 'Sometimes' },
        { value: 'high', label: 'Most days' }
      ]
    },
    {
      key: 'sensitivity',
      title: 'How would you describe your comfort preference?',
      options: [
        { value: 'sensitive', label: 'I prefer gentle, simple formulas' },
        { value: 'resilient', label: 'I am comfortable with active ingredients' }
      ]
    },
    {
      key: 'complexity',
      title: 'How many steps do you want?',
      options: [
        { value: 'minimal', label: 'Minimal — 2 steps' },
        { value: 'balanced', label: 'Balanced — 3 steps' },
        { value: 'complete', label: 'Complete — 4 steps' }
      ]
    },
    {
      key: 'time',
      title: 'When do you most enjoy your routine?',
      options: [
        { value: 'am', label: 'Mornings' },
        { value: 'pm', label: 'Evenings' },
        { value: 'both', label: 'Both' }
      ]
    },
    {
      key: 'interest',
      title: 'What are you most interested in?',
      options: [
        { value: 'skincare', label: 'Skincare' },
        { value: 'devices', label: 'Beauty devices' },
        { value: 'both', label: 'Both' }
      ]
    }
  ];

  function money(cents, sample) {
    // Derive currency formatting from a sample formatted price when possible.
    var value = (cents / 100).toFixed(2);
    if (!sample) return value;
    var match = sample.match(/^([^\d]*)[\d.,\s]+(.*)$/);
    if (!match) return value;
    return match[1] + value + match[2];
  }

  function score(routine, answers) {
    var total = 0;
    Object.keys(answers).forEach(function (key) {
      var rule = routine.match[key];
      if (!rule || rule === 'any') return;
      if (rule === answers[key]) total += 2;
      else if (key === 'time' && (rule === 'both' || answers[key] === 'both')) total += 1;
      else if (key === 'interest' && (rule === 'both' || answers[key] === 'both')) total += 1;
    });
    return total;
  }

  function initQuiz(root) {
    if (!root || root.dataset.quizReady === 'true') return;
    root.dataset.quizReady = 'true';

    var dataEl = root.querySelector('[data-quiz-routines]');
    var routines = [];
    try { routines = JSON.parse(dataEl.textContent || '[]'); } catch (e) { routines = []; }
    routines = routines.filter(function (r) { return r.products && r.products.length; });

    var intro = root.querySelector('[data-quiz-intro]');
    var shell = root.querySelector('[data-quiz-shell]');
    var stage = root.querySelector('[data-quiz-stage]');
    var results = root.querySelector('[data-quiz-results]');
    var bar = root.querySelector('[data-quiz-bar]');
    var count = root.querySelector('[data-quiz-count]');
    var backBtn = root.querySelector('[data-quiz-back]');
    var restartBtn = root.querySelector('[data-quiz-restart]');
    var startBtn = root.querySelector('[data-quiz-start]');
    var form = root.querySelector('[data-quiz-form]');

    var answers = {};
    var index = 0;

    function renderStep() {
      var q = QUESTIONS[index];
      var chosen = answers[q.key];
      stage.innerHTML = '';

      var fieldset = document.createElement('fieldset');
      fieldset.className = 'quiz__fieldset';

      var legend = document.createElement('legend');
      legend.className = 'type-h3 quiz__question';
      legend.textContent = q.title;
      fieldset.appendChild(legend);

      if (q.help) {
        var help = document.createElement('p');
        help.className = 'type-small quiz__help';
        help.textContent = q.help;
        fieldset.appendChild(help);
      }

      var list = document.createElement('div');
      list.className = 'quiz__options';

      q.options.forEach(function (opt, i) {
        var id = 'q-' + q.key + '-' + opt.value;
        var label = document.createElement('label');
        label.className = 'quiz__option';
        label.setAttribute('for', id);

        var input = document.createElement('input');
        input.type = 'radio';
        input.name = q.key;
        input.value = opt.value;
        input.id = id;
        if (chosen === opt.value) input.checked = true;
        input.addEventListener('change', function () {
          answers[q.key] = opt.value;
          window.setTimeout(next, 180);
        });

        var text = document.createElement('span');
        text.textContent = opt.label;

        label.appendChild(input);
        label.appendChild(text);
        list.appendChild(label);
        if (i === 0) label.dataset.first = 'true';
      });

      fieldset.appendChild(list);
      stage.appendChild(fieldset);

      bar.style.width = ((index) / QUESTIONS.length) * 100 + '%';
      count.textContent = 'Question ' + (index + 1) + ' of ' + QUESTIONS.length;
      backBtn.disabled = index === 0;

      var focusTarget = stage.querySelector('input:checked') || stage.querySelector('input');
      if (focusTarget) focusTarget.focus({ preventScroll: true });
    }

    function next() {
      if (index < QUESTIONS.length - 1) { index += 1; renderStep(); return; }
      showResults();
    }

    function start() {
      intro.hidden = true;
      results.hidden = true;
      results.innerHTML = '';
      shell.hidden = false;
      index = 0;
      answers = {};
      renderStep();
      shell.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function bestRoutine() {
      if (!routines.length) return null;
      var best = null;
      var bestScore = -1;
      routines.forEach(function (r) {
        var s = score(r, answers);
        if (s > bestScore) { bestScore = s; best = r; }
      });
      return best;
    }

    function showResults() {
      bar.style.width = '100%';
      shell.hidden = true;
      results.hidden = false;
      results.innerHTML = '';

      var routine = bestRoutine();
      if (!routine) {
        results.innerHTML = '<p class="type-body">No routine is configured yet. Please check back soon.</p>';
        return;
      }

      var wanted = { minimal: 2, balanced: 3, complete: 4 }[answers.complexity] || routine.products.length;
      var products = routine.products.slice(0, Math.max(2, Math.min(wanted, routine.products.length)));

      var head = document.createElement('div');
      head.className = 'quiz__result-head';
      head.innerHTML =
        '<p class="eyebrow">' + (root.dataset.resultsLabel || 'Your recommended routine') + '</p>' +
        '<h2 class="type-h2">' + routine.name + '</h2>' +
        (routine.summary ? '<p class="type-body quiz__result-summary">' + routine.summary + '</p>' : '');
      results.appendChild(head);

      var list = document.createElement('ol');
      list.className = 'quiz__result-list';
      var total = 0;
      var sample = products[0] ? products[0].price_formatted : '';

      products.forEach(function (p, i) {
        total += p.price;
        var li = document.createElement('li');
        li.className = 'quiz__result-item';

        var media = p.image
          ? '<a class="quiz__result-media" href="' + p.url + '"><img src="' + p.image + '" alt="' + (p.image_alt || p.title) + '" loading="lazy" width="600" height="600"></a>'
          : '<span class="quiz__result-media quiz__result-media--empty"></span>';

        var meta = [];
        meta.push('Step ' + (i + 1));
        if (p.placement) meta.push(p.placement);

        li.innerHTML = media +
          '<div class="quiz__result-body">' +
            '<p class="quiz__result-meta type-small">' + meta.join(' · ') + '</p>' +
            '<a class="quiz__result-title" href="' + p.url + '">' + p.title + '</a>' +
            (p.reason ? '<p class="type-small quiz__result-reason">' + p.reason + '</p>' : '') +
            '<p class="quiz__result-price">' + p.price_formatted +
              (p.compare_at > p.price ? ' <span class="price--compare">' + p.compare_at_formatted + '</span>' : '') +
            '</p>' +
          '</div>';
        list.appendChild(li);
      });
      results.appendChild(list);

      var footer = document.createElement('div');
      footer.className = 'quiz__result-footer';
      footer.innerHTML =
        '<div class="quiz__total"><span class="type-small">Routine total</span><strong>' + money(total, sample) + '</strong></div>' +
        '<button type="button" class="btn btn--primary quiz__add">' + (root.dataset.addLabel || 'Add routine to cart') + '</button>' +
        (routine.ritual_url ? '<a class="btn btn--outline quiz__ritual" href="' + routine.ritual_url + '">' + (routine.ritual_label || 'View this ritual') + '</a>' : '') +
        '<button type="button" class="btn btn--ghost quiz__again" data-quiz-restart>Retake quiz</button>';
      results.appendChild(footer);

      footer.querySelector('.quiz__add').addEventListener('click', function () {
        form.querySelectorAll('input').forEach(function (n) { n.remove(); });
        products.forEach(function (p, i) {
          var id = document.createElement('input');
          id.type = 'hidden';
          id.name = 'items[' + i + '][id]';
          id.value = p.variant_id;
          var qty = document.createElement('input');
          qty.type = 'hidden';
          qty.name = 'items[' + i + '][quantity]';
          qty.value = '1';
          form.appendChild(id);
          form.appendChild(qty);
        });
        if (form.requestSubmit) form.requestSubmit();
        else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
      });

      footer.querySelector('.quiz__again').addEventListener('click', start);
      results.scrollIntoView({ behavior: 'smooth', block: 'start' });
      var heading = results.querySelector('.type-h2');
      if (heading) { heading.setAttribute('tabindex', '-1'); heading.focus({ preventScroll: true }); }
    }

    if (startBtn) startBtn.addEventListener('click', start);
    backBtn.addEventListener('click', function () { if (index > 0) { index -= 1; renderStep(); } });
    restartBtn.addEventListener('click', start);

    root.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !shell.hidden) { shell.hidden = true; intro.hidden = false; }
    });
  }

  function boot() { document.querySelectorAll('[data-quiz]').forEach(initQuiz); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
